import { render, staticRenderFns } from "./TeamTrainingPopupFrame.vue?vue&type=template&id=6d044a32&scoped=true&"
import script from "./TeamTrainingPopupFrame.vue?vue&type=script&lang=js&"
export * from "./TeamTrainingPopupFrame.vue?vue&type=script&lang=js&"
import style0 from "./TeamTrainingPopupFrame.vue?vue&type=style&index=0&id=6d044a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d044a32",
  null
  
)

export default component.exports